var _path, _g, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoticeIcon = function SvgNoticeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 119,
    viewBox: "0 0 128 119",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1120_3619)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1120_3619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 119
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H128V118.026H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1120_3619)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.094 118.026C9.69729 118.026 4.84073 115.253 2.10355 110.61C-0.633531 105.966 -0.703521 100.38 1.91684 95.6696L50.8226 7.74316C53.5195 2.89473 58.4455 0 63.9999 0C69.5546 0 74.4807 2.89473 77.177 7.74316L126.084 95.6696C128.704 100.381 128.633 105.966 125.897 110.61C123.159 115.253 118.303 118.026 112.906 118.026H15.094Z",
    fill: "#E5AE1D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84288 96.876L53.566 8.66724C58.1127 0.435628 69.8872 0.435628 74.4341 8.66724L123.157 96.876C127.575 104.874 121.823 114.701 112.723 114.701H15.277C6.17746 114.701 0.425073 104.874 4.84288 96.876Z",
    fill: "#FFCD36",
    fillOpacity: 0.957386
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7967 97.4163V89.9749C55.7967 88.6914 56.8168 87.6509 58.0753 87.6509H69.8523C71.1107 87.6509 72.1309 88.6914 72.1309 89.9749V97.4163C72.1309 98.6998 71.1107 99.7403 69.8523 99.7403H58.0753C56.8168 99.7403 55.7967 98.6998 55.7967 97.4163ZM56.2864 80.9658L53.1948 46.0755V45.4174C53.1948 43.7453 54.524 42.3896 56.1635 42.3896H71.8366C73.4762 42.3896 74.8052 43.7453 74.8052 45.4174V46.0755L71.6458 80.9714C71.5112 82.4588 70.2878 83.5966 68.8233 83.5966H59.1094C57.6428 83.5966 56.4183 82.4555 56.2864 80.9658Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1120_3619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 119,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoticeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notice-icon.63b09643.svg";
export { ForwardRef as ReactComponent };